﻿import { largeListsOps } from "../api/operations";
import { ROLE } from "../Auth/useRole";
import { entityFactory } from "../hooks/useEntity";
import { defineEntity } from "../api/entity";
export const conf = defineEntity({
  ...entityFactory("large-list"),
  endpoint: "large-lists",
  operations: largeListsOps,
  roleView: [ROLE.LARGE_LIST_VIEW, ROLE.LARGE_LIST_ADMIN],
  roleAdmin: [ROLE.LARGE_LIST_ADMIN],
  singularName: (t) => t("Large list"),
  name: (t) => t("Large lists"),
  syncCustomerFilter: true,
});
export default conf;
